import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/admin/services/user.service';
import { ContributorAddModel } from 'src/app/admin/models/contributor.add.model';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { CountryService } from 'src/app/services/country.service';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';
import { Constants } from 'src/app/helpers/constants';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-user-add-contributor',
    templateUrl: './user.add.contributor.component.html'
})
export class UserAddContributorComponent implements OnInit {
    isModelLoaded = false;
    emailPattern: string;
    confirmPassword: string;
    model: ContributorAddModel = new ContributorAddModel();
    countries = Array<SelectListItemModel>();
    currencies = Array<SelectListItemModel>();

    frontSideUploader: FileUploader;
    backSideUploader: FileUploader;
    otherUploader: FileUploader;

    id: string;

    passwordPattern: string;

    maxDateOfBirth: any;
    minDateOfBirth: any;

    phoneMask: string;
    dob: any;

    get urls() {
        return PageUrls;
    }

    constructor(private router: Router, private route: ActivatedRoute,
        private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService, private countryService: CountryService,
        private userService: UserService,
        private authService: AuthService) {
    }

    ngOnInit() {
        this.emailPattern = Constants.emailValidationRegEx;
        this.passwordPattern = Constants.passwordRegEx;
        this.getCountries();
        this.getCurrencies();
        this.getIpAddress();

        this.frontSideUploader = new FileUploader({
            url: `${environment.apiUrl}/api/admin/user/upload-contributor-identity-image`,
            disableMultipart: false,
            formatDataFunctionIsAsync: false,
            allowedMimeType: ['image/jpeg', 'image/jpg'],
            autoUpload: false,
            authToken: `Bearer ${this.authService.getAuthToken()}`
        });

        this.frontSideUploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed;
        this.frontSideUploader.onAfterAddingFile = this.onAfterFrontSideAddingFile;
        this.frontSideUploader.onCompleteAll = this.onCompleteAll;

        this.frontSideUploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('type', 1);
            form.append('contributorId', this.id);
        };

        this.backSideUploader = new FileUploader({
            url: `${environment.apiUrl}/api/admin/user/upload-contributor-identity-image`,
            disableMultipart: false,
            formatDataFunctionIsAsync: false,
            allowedMimeType: ['image/jpeg', 'image/jpg'],
            autoUpload: false,
            authToken: `Bearer ${this.authService.getAuthToken()}`
        });

        this.backSideUploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed;
        this.backSideUploader.onAfterAddingFile = this.onAfterBackSideAddingFile;
        this.backSideUploader.onCompleteAll = this.onCompleteAll;

        this.backSideUploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('type', 2);
            form.append('contributorId', this.id);
        };

        this.otherUploader = new FileUploader({
            url: `${environment.apiUrl}/api/admin/user/upload-contributor-identity-image`,
            disableMultipart: false,
            formatDataFunctionIsAsync: false,
            allowedMimeType: ['image/jpeg', 'image/jpg'],
            autoUpload: false,
            authToken: `Bearer ${this.authService.getAuthToken()}`
        });

        this.otherUploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed;
        this.otherUploader.onAfterAddingFile = this.onAfterOtherAddingFile;
        this.otherUploader.onCompleteAll = this.onCompleteAll;

        this.otherUploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('type', 3);
            form.append('contributorId', this.id);
        };

        const currentDate = new Date();
        this.minDateOfBirth = { year: 1800, month: 1, day: 1 };
        this.maxDateOfBirth = { year: currentDate.getFullYear(), month: (currentDate.getMonth() + 1), day: currentDate.getDate() };
    }

    getCountries() {
        this.ngxSpinner.show();
        this.countryService.getSelectList()
            .subscribe(response => {
                this.countries = response;
                this.ngxSpinner.hide();
            },
                error => {
                    console.error(error);
                    this.ngxSpinner.hide();
                    AppUtils.processErrorResponse(this.toastr, error);
                });
    }

    getCurrencies() {
        this.ngxSpinner.show();
        this.countryService.getCurrencySelectList()
            .subscribe(response => {
                this.currencies = response;
                this.ngxSpinner.hide();
            },
                error => {
                    console.error(error);
                    this.ngxSpinner.hide();
                    AppUtils.processErrorResponse(this.toastr, error);
                });
    }

    submit() {
        this.ngxSpinner.show();
        this.model.dateOfBirth = AppUtils.getFormattedDate(this.dob);
        this.userService.addContributor(this.model).subscribe(
            (id: string) => {
                this.id = id;
                this.uploadImages();
            },
            error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
        this.toastr.info('Only jpg/jpeg images are allowed.');
    }

    onAfterFrontSideAddingFile = (fileItem: FileItem) => {
        if (!fileItem.file.name.trim().toLowerCase().endsWith('.jpeg')
            && !fileItem.file.name.trim().toLowerCase().endsWith('.jpg')) {
            fileItem.remove();
            this.toastr.info('Only jpg/jpeg images are allowed.');
            return;
        }
        const latestFile = this.frontSideUploader.queue[this.frontSideUploader.queue.length - 1];
        this.frontSideUploader.queue = [];
        this.frontSideUploader.queue.push(latestFile);
    }

    onAfterBackSideAddingFile = (fileItem: FileItem) => {
        if (!fileItem.file.name.trim().toLowerCase().endsWith('.jpeg')
            && !fileItem.file.name.trim().toLowerCase().endsWith('.jpg')) {
            fileItem.remove();
            this.toastr.info('Only jpg/jpeg images are allowed.');
            return;
        }
        const latestFile = this.backSideUploader.queue[this.backSideUploader.queue.length - 1];
        this.backSideUploader.queue = [];
        this.backSideUploader.queue.push(latestFile);
    }

    onAfterOtherAddingFile = (fileItem: FileItem) => {
        if (!fileItem.file.name.trim().toLowerCase().endsWith('.jpeg')
            && !fileItem.file.name.trim().toLowerCase().endsWith('.jpg')) {
            fileItem.remove();
            this.toastr.info('Only jpg/jpeg images are allowed.');
            return;
        }
        const latestFile = this.otherUploader.queue[this.otherUploader.queue.length - 1];
        this.otherUploader.queue = [];
        this.otherUploader.queue.push(latestFile);
    }

    onCompleteAll = () => {
        const forntSideFiledItems = this.frontSideUploader.queue.filter(x => x.isError);
        const backSideFailedItems = this.backSideUploader.queue.filter(x => x.isError);
        const otherFailedItems = this.otherUploader.queue.filter(x => x.isError);
        if (forntSideFiledItems.length === 0 && backSideFailedItems.length === 0 && otherFailedItems.length === 0) {
            this.ngxSpinner.hide();
            this.router.navigateByUrl(`${PageUrls.Admin.UserContributor}`);
            setTimeout(() => {
                this.toastr.success('Photographer has been added successfully');
            });
        }
    }

    uploadImages() {
        let itemsToUpload = this.frontSideUploader.queue.filter(x => !x.isUploaded || x.isCancel || x.isError);
        itemsToUpload = itemsToUpload.concat(this.backSideUploader.queue.filter(x => !x.isUploaded || x.isCancel || x.isError));
        itemsToUpload = itemsToUpload.concat(this.otherUploader.queue.filter(x => !x.isUploaded || x.isCancel || x.isError));
        if (itemsToUpload.length === 0) {
            this.ngxSpinner.hide();
            this.router.navigateByUrl(`${PageUrls.Admin.UserContributor}`);
            setTimeout(() => {
                this.toastr.success('Photographer has been updated successfully');
            });
        }
        itemsToUpload.forEach(query => {
            query.upload();
        });
    }

    getIpAddress() {
        fetch(environment.ipifyApiEndPoint)
            .then(response => response.json())
            .then(result => {
                this.model.ipAddress = result.ip;
            })
            .catch(error => console.log('error', error));
    }

    onFileClick(event: any) {
        event.target.value = '';
    }
}
